import { render, staticRenderFns } from "./StudentHeader.vue?vue&type=template&id=f20c102e"
import script from "./StudentHeader.vue?vue&type=script&lang=js"
export * from "./StudentHeader.vue?vue&type=script&lang=js"
import style0 from "./StudentHeader.vue?vue&type=style&index=0&id=f20c102e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports